var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"uppercase text-center mt-2",staticStyle:{"color":"#0064b2","font-family":"'Times new roman'","font-weight":"bold"}},[_vm._v("\n        CHÀO MỪNG ĐẾN VỚI TRANG VÀNG\n      ")])])])])
}]

export { render, staticRenderFns }